import React, { FC } from 'react';
import { GetAllCustomerParents_getAllCustomerParents as CustomerParent } from '../../types/schemaTypes';
import { useLazyLoading } from '../_common';
import CustomerParentItem from './CustomerParentItem';
import './CustomerParents.scss';

interface CustomerParentListProps {
    customerParents: CustomerParent[];
    refetch?: () => void;
    isLoading: boolean;
    canEditCustomerParents: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
    onEditClick: (CustomerParent: CustomerParent) => void;
    onDelete?: (record: any) => void;
}

const CustomerParentList: FC<CustomerParentListProps> = ({
    customerParents,
    refetch,
    isLoading,
    isEndOfResults,
    onLoadMore,
    onEditClick,
    canEditCustomerParents,
    onDelete,
}: CustomerParentListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('customerParentList', isLoading, isEndOfResults, onLoadMore);

    if (refetch) {
        refetch();
    }

    return (
        <div className="CustomerParents-List" onScroll={handleScroll}>
            {customerParents.map((customer, index) => (
                <CustomerParentItem
                    key={customer.id ? customer.id.toString() : '0'}
                    index={index}
                    canEditCustomerParents={canEditCustomerParents}
                    customerParent={customer}
                    onEditClick={onEditClick}
                    onDelete={onDelete}
                ></CustomerParentItem>
            ))}
        </div>
    );
};

export default CustomerParentList;

